import React, { Component, Fragment, useEffect, useState, useRef } from 'react';
import './style.css';
import { useHistory, useLocation, Link } from "react-router-dom"
import { Layout, Menu, Breadcrumb, Table, Button, Space, Form, Input, Row, Col, Checkbox, Divider, Card, Radio, Spin, Select } from 'antd';
import { MinusCircleOutlined, PlusOutlined, SearchOutlined, MoreOutlined, SyncOutlined, EditOutlined } from '@ant-design/icons';
import { FaRegEdit, FaEdit, FaRegSave } from "react-icons/fa";
import { HiOutlinePencil } from "react-icons/hi";
import Container from '../Layout/Container';
import { Wizard, Steps, Step } from 'react-albus';
import { useSelector, useDispatch } from 'react-redux';
import { getDepartment, getDepartmentSelector, updateDepartmentAsyn, clearState } from './viewDepartmentSlice';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
const { Header, Content, Footer } = Layout;
const { Search, TextArea } = Input;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;


export default function ViewDepartment() {
  const [isDepReadonly, setDepReadonly] = React.useState(true);
  const [isToast, setToast] = React.useState(false);
  const [departmentObj, setDepartment] = React.useState({});
  const [isLoading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  let history = useHistory()
  const location = useLocation();
  const [state, setState] = useState({})
  const { isFetching, isSuccess, isError, isUpdated, errorMessage, department } = useSelector(
    getDepartmentSelector
  );

  const [form] = Form.useForm()

  useEffect(() => {
    // console.log(location.state.departmentName);
    setLoading(true);
    setToast(false);
    dispatch(clearState());
    dispatch(getDepartment(location.state.departmentName));

  }, []);

  useEffect(() => {

    if (isUpdated) {
      setLoading(false);
    }

    if (isError) {
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);
    }
    if (isSuccess) {

      //console.log(department);
      setTimeout(() => {
        setDepartment(department);
        setLoading(false);
      }, 1000);

    }

  }, [isError, isSuccess, isUpdated, setLoading, setDepartment, form, setToast]);



  const updateDepartment = () => {
    dispatch(clearState());
    let name = form.getFieldValue('name');
    let arr_referenceNumber = form.getFieldValue('arr_referenceNumber');
    let referenceNumber = arr_referenceNumber.map(function ({ referenceNumber }) {
      return referenceNumber;
    });
    let description = form.getFieldValue('description');
    let data = {
      "departmentName": departmentObj.name,
      "change": {
        "name": name,
        "referenceNumber": referenceNumber,
        "description": description
      }
    };

    setLoading(true);
    dispatch(updateDepartmentAsyn(data));
  }

  const handleViewDepartment = (row) => {
    // console.log(row)
    history.push({
      pathname: '/view-department',
      // search: '?query=abc',
      state: { departmentName: row.departmentName }
    });
  }

  return (
    <>
      <Container className={'bodyClass'}>
        <Breadcrumb style={{ margin: '16px 0', paddingLeft: 50, marginBottom: 0 }} separator=">">
          <Breadcrumb.Item>Departments</Breadcrumb.Item>
          <Breadcrumb.Item>View Department</Breadcrumb.Item>
        </Breadcrumb>

        <div className="site-layout-content sitelayoutcontent" style={{ marginTop: 0, paddingTop: 0 }}>
          {isToast &&
            <Toaster
              toastOptions={{
                className: '',
                style: {
                  border: '1px solid #713200',
                  padding: '16px',
                  color: '#713200',
                  marginTop: 50
                },
              }}
            >
              {(t) => (
                <ToastBar toast={t}>
                  {({ icon, message }) => (
                    <>
                      {icon}
                      {message}
                      {t.type !== 'loading' && (
                        <button onClick={() => toast.dismiss(t.id)}>X</button>
                      )}
                    </>
                  )}
                </ToastBar>
              )}
            </Toaster>
          }
          <div style={{ padding: 24, paddingTop: 16 }}>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%', position: 'fixed', zIndex: 1, left: 0, right: 0, top: '45%', bottom: 0 }} spinning={isLoading} />
            <div>
              <Row style={{ paddingTop: 35, paddingBottom: 20, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderTop: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8' }}>
                <Col span="2"></Col>
                <Col span="19" >
                  <h1 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 24 }}>{departmentObj ? departmentObj.name : 'View'} Department Details</h1>
                </Col>
                <Col span="3" style={{ paddingLeft: 25, float: 'right', fontWeight: 'bold', fontStyle: 'normal', fontSize: 24 }}>
                  <Button onClick={() => handleViewDepartment(departmentObj)}><HiOutlinePencil /> &nbsp;&nbsp;EDIT</Button>
                </Col>
              </Row>
              <Row style={{ paddingTop: 35, paddingBottom: 20, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderTop: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8' }}>
                <Col span="2"></Col>
                <Col span={5}>
                  <h2 className={'branchh2'}>Department</h2>
                </Col>
                <Col span={17}>
                  <a style={{ fontSize: 22, fontWeight: 500 }} className={'titleClass'}>
                    {departmentObj ? departmentObj.name : ' '} Department
                  </a>
                  <br />
                  <p className={'pclass'}>Reference No</p>
                  <p className={'pdescription'}>
                    {departmentObj ? departmentObj.referenceNumber ? departmentObj.referenceNumber.join() : '' : ' '}
                  </p>
                  <p className={'pclass'}>Description</p>
                  <p className={'pdescription'}>
                    {departmentObj ? departmentObj.description : ' '}
                  </p>
                  <Divider className={'antdividerhorizontal'} />
                </Col>

                {/* ......branch..... */}
                <Col span="2"></Col>
                <Col span={5}>
                  <h2 className={'branchh2'}>Branch</h2>
                  <a className={'branchanchor'}>{departmentObj.branch_data ? departmentObj.branch_data.length > 1 ? departmentObj.branch_data.length + ' Branches' : departmentObj.branch_data.length + ' Branch' : 0}</a>
                </Col>
                <Col span={17}>

                  {departmentObj && departmentObj.branch_data &&
                    <>
                      {
                        departmentObj.branch_data.map(function (br) {
                          return <>
                            <a style={{ fontSize: 22, fontWeight: 500 }} className={'titleClass'}>
                              {br.b_name} <span style={{ color: "#000", fontWeight: 300 }}>({br.bd_directorates.length > 1 ? br.bd_directorates.length + ' Directorates' : br.bd_directorates.length + ' Directorate'} )</span>
                            </a>
                            <br />
                            <p className={'pclass'}>Reference No</p>
                            <p className={'pdescription'}>
                              {br.b_referenceNumber ? br.b_referenceNumber.join() : ''}
                            </p>
                            <p className={'pclass'}>Description</p>
                            <p className={'pdescription'}>
                              {br.b_description}
                            </p>
                            <div style={{ padding: 35, paddingTop: 25 }}>
                              {br.bd_directorates &&
                                <>
                                  {
                                    br.bd_directorates.map(function (dr) {
                                      return <>
                                        <a style={{ fontSize: 22, fontWeight: 500 }} className={'titleClass'}>
                                          {dr.bd_name}
                                        </a>
                                        <br />
                                        <p className={'pclass'}>Reference No</p>
                                        <p className={'pdescription'}>
                                          {dr.bd_referenceNumber ? dr.bd_referenceNumber.join() : ''}
                                        </p>
                                        <p className={'pclass'}>Description</p>
                                        <p className={'pdescription'}>
                                          {dr.bd_description}
                                        </p>
                                        <div>

                                        </div>
                                      </>
                                    })
                                  }
                                </>
                              }
                            </div>
                          </>
                        })
                      }
                    </>
                  }


                  <Divider className={'antdividerhorizontal'} />
                </Col>

                {/* ......independent office..... */}
                <Col span="2"></Col>
                <Col span={5}>
                  <h2 className={'branchh2'} style={{ lineHeight: 1.2 }}>Independent Office</h2>
                  <a className={'branchanchor'}>{departmentObj.io_independentOffices ? departmentObj.io_independentOffices.length > 1 ? departmentObj.io_independentOffices.length + ' Independent Offices' : departmentObj.io_independentOffices.length + ' Independent Office' : 0}</a>
                </Col>
                <Col span={17}>

                  {departmentObj && departmentObj.io_independentOffices &&
                    <>
                      {
                        departmentObj.io_independentOffices.map(function (br) {
                          return <>
                            <a style={{ fontSize: 22, fontWeight: 500 }} className={'titleClass'}>
                              {br.io_name}
                            </a>
                            <br />
                            <p className={'pclass'}>Reference No</p>
                            <p className={'pdescription'}>
                              {br.io_referenceNumber ? br.io_referenceNumber.join() : ''}
                            </p>
                            <p className={'pclass'}>Description</p>
                            <p className={'pdescription'}>
                              {br.io_description}
                            </p>
                          </>
                        })
                      }
                    </>
                  }


                  <Divider className={'antdividerhorizontal'} />
                </Col>


                {/* ......independent directorate..... */}
                <Col span="2"></Col>
                <Col span={5}>
                  <h2 className={'branchh2'} style={{ lineHeight: 1.2 }}>Independent <br /> Directorates</h2>
                  <a className={'branchanchor'}>{departmentObj.id_directorates ? departmentObj.id_directorates.length > 1 ? departmentObj.id_directorates.length + ' Independent Directorates' : departmentObj.id_directorates.length + ' Independent \n Directorate' : 0}</a>
                </Col>
                <Col span={17}>

                  {departmentObj && departmentObj.id_directorates &&
                    <>
                      {
                        departmentObj.id_directorates.map(function (br) {
                          return <>
                            <a style={{ fontSize: 22, fontWeight: 500 }} className={'titleClass'}>
                              {br.id_name}
                            </a>
                            <br />
                            <p className={'pclass'}>Reference No</p>
                            <p className={'pdescription'}>
                              {br.id_referenceNumber ? br.id_referenceNumber.join() : ''}
                            </p>
                            <p className={'pclass'}>Description</p>
                            <p className={'pdescription'}>
                              {br.id_description}
                            </p>
                          </>
                        })
                      }
                    </>
                  }


                  <Divider className={'antdividerhorizontal'} />
                </Col>
              </Row>
            </div>

          </div>

        </div>
      </Container>
    </>
  );
}
